import { useEffect } from "react";

import { atom, useAtom } from "jotai";

import { useLocation } from "@redwoodjs/router";

import { camelCaseToTitleCase } from "src/lib/format";

const dashboardAtom = atom({
  breadcrumb: [],
  currentPage: null,
});

const areBreadcrumbsEqual = (left, right) => {
  if (left.length !== right.length) {
    return false;
  }

  return left.every(
    (item, index) =>
      item.name === right[index]?.name && item.url === right[index]?.url
  );
};

const areShallowEqual = (left, right) => {
  if (left === right) {
    return true;
  }

  if (!left || !right) {
    return false;
  }

  const leftKeys = Object.keys(left);
  const rightKeys = Object.keys(right);

  if (leftKeys.length !== rightKeys.length) {
    return false;
  }

  return leftKeys.every((key) => Object.is(left[key], right[key]));
};

/**
 * useDashboard is a hook that provides access to the dashboard state.
 */
const useDashboard = (currentPage) => {
  const [dashboard, setDashboard] = useAtom(dashboardAtom);
  const { pathname } = useLocation();

  // const getSetter = (key) => (value) => {
  //   setDashboard({ ...dashboard, [key]: value });
  // };

  useEffect(() => {
    const parts = pathname.split("/").filter(Boolean);
    const breadcrumb = parts.map((part, index) => {
      return {
        name:
          currentPage?.id === part
            ? currentPage?.name
            : camelCaseToTitleCase(part),
        url: "/" + parts.slice(0, index + 1).join("/"),
      };
    });

    setDashboard((prev) => {
      const breadcrumbChanged = !areBreadcrumbsEqual(
        prev.breadcrumb,
        breadcrumb
      );
      const currentPageChanged =
        currentPage && !areShallowEqual(prev.currentPage, currentPage);

      if (!breadcrumbChanged && !currentPageChanged) {
        return prev;
      }

      const nextDashboard = { ...prev };

      if (breadcrumbChanged) {
        nextDashboard.breadcrumb = breadcrumb;
      }

      if (currentPageChanged) {
        nextDashboard.currentPage = currentPage;
      }

      return nextDashboard;
    });
  }, [currentPage, pathname, setDashboard]);

  return dashboard;
};

export default useDashboard;
